
import { HeroSection } from './components/HeroSection';
import { WhyDifferentSection } from './components/WhyDifferentSection';
import { CoursesSection } from './components/CoursesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { MentorSection } from './components/MentorSection';
import { CommunitySection } from './components/CommunitySection';
import { OfferStackSection } from './components/OfferStackSection';
import { CheckoutSection } from './components/CheckoutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <WhyDifferentSection />
      <CoursesSection />
      <BenefitsSection />
      <MentorSection />
      <CommunitySection />
      <OfferStackSection />
      <CheckoutSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
